export default __webpack_public_path__ + "static/media/EmittanceImg.5505f5d0.png";